<template>
  <div>
    <div class="row">
      <div class="col-md-4" style="text-align: left" v-if="showForm">
        <a @click="closeForm">{{ $t('content.back_link') }}</a>
      </div>
      <div
        class="col-md-4 col-md-offset-9"
        v-if="!showForm"
        style="margin-bottom: 4%"
      >
        <a-button type="primary" @click="openForm">{{
          $t('content.add_content_btn')
        }}</a-button>
      </div>
    </div>
    <div>
      <dynamic-contents-list
        v-if="!showForm"
        :mergeContentService="mergeContentService"
        @edit="editContent"
      />
    </div>
    <div class="row">
      <dynamic-content-form
        v-if="showForm"
        :dynamicContent="dynamicContent"
        @saved="closeForm"
      />
    </div>
  </div>
</template>

<script>
import DynamicContentForm from './DynamicContentForm.vue';
import DynamicContentsList from './DynamicContentsList.vue';
import MergeContentClient from './mergeContentClient.js';
import ContentClient from './contentClient';
import MergeContentService from './mergeContentService.js';

const mergeContentClient = MergeContentClient(process.env.VUE_APP_ED_API);
const contentClient = ContentClient(process.env.VUE_APP_CONTENT_API);

export default {
  name: 'DynamicSection',
  components: {
    DynamicContentForm,
    DynamicContentsList
  },
  data: function () {
    return {
      showForm: false,
      mergeContentService: MergeContentService(
        mergeContentClient,
        contentClient
      ),
      dynamicContent: undefined
    };
  },
  methods: {
    openForm: function () {
      this.dynamicContent = undefined;
      this.showForm = true;
    },
    closeForm: function () {
      this.showForm = false;
    },
    editContent: function (e) {
      this.dynamicContent = e;
      this.showForm = true;
    }
  }
};
</script>

<style scoped></style>
